import React, { useState } from 'react'
import { Card, CardBody, Button, Modal, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import Success from 'pages/NotificationModal/Success'
import ErrorModal from 'pages/NotificationModal/Error'

const API_URL = process.env.REACT_APP_API_URL

const FollowupMgmtDelete = () => {
    const [tenantShortname, setTenantShortname] = useState('')
    const [mailTracker, setMailTracker] = useState('')
    const [touched, setTouched] = useState({ tenantShortname: false, mailTracker: false })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const handleDelete = async (e) => {
        e.preventDefault()
        setTouched({ tenantShortname: true, mailTracker: true })
        if (!tenantShortname || !mailTracker) return

        setLoading(true)
        try {
            const url = `${API_URL}crs/followup-mgmt?tenant_shortname=${encodeURIComponent(tenantShortname)}&mail_tracker=${encodeURIComponent(mailTracker)}`
            const response = await fetch(url, { method: 'DELETE', credentials: 'include' })
            if (!response.ok) {
                let msg = 'Failed to delete followup record.'
                try { const data = await response.json(); msg = data.message || msg } catch (_) {}
                throw new Error(msg)
            }
            setShowSuccess(true)
        } catch (err) {
            setErrorMessage(err.message || 'Failed to delete followup record.')
            setShowError(true)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Modal isOpen={showSuccess} toggle={() => setShowSuccess(false)} centered size="sm">
                <Success
                    message="Followup record deleted successfully!"
                    close={() => {
                        setShowSuccess(false)
                        setTenantShortname('')
                        setMailTracker('')
                        setTouched({ tenantShortname: false, mailTracker: false })
                    }}
                />
            </Modal>

            <Modal isOpen={showError} toggle={() => setShowError(false)} centered size="sm">
                <ErrorModal
                    message={errorMessage}
                    closeModal={() => setShowError(false)}
                />
            </Modal>

            <Card className="p-3">
                <CardBody>
                    <Form onSubmit={handleDelete}>
                        <FormGroup>
                            <Label for="tenantShortname" style={{ fontWeight: '600', fontSize: '13px' }}>
                                Tenant Shortname
                            </Label>
                            <Input
                                id="tenantShortname"
                                type="text"
                                value={tenantShortname}
                                onChange={(e) => setTenantShortname(e.target.value)}
                                onBlur={() => setTouched(t => ({ ...t, tenantShortname: true }))}
                                placeholder="Enter tenant shortname"
                                invalid={touched.tenantShortname && !tenantShortname}
                                style={{ fontSize: '13px' }}
                            />
                            <FormFeedback>Tenant Shortname is required.</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label for="mailTracker" style={{ fontWeight: '600', fontSize: '13px' }}>
                                Mail Tracker
                            </Label>
                            <Input
                                id="mailTracker"
                                type="text"
                                value={mailTracker}
                                onChange={(e) => setMailTracker(e.target.value)}
                                onBlur={() => setTouched(t => ({ ...t, mailTracker: true }))}
                                placeholder="Enter mail tracker"
                                invalid={touched.mailTracker && !mailTracker}
                                style={{ fontSize: '13px' }}
                            />
                            <FormFeedback>Mail Tracker is required.</FormFeedback>
                        </FormGroup>
                        <div className="modal-footer px-0 pb-0">
                            <Button
                                type="submit"
                                color="danger"
                                size="sm"
                                disabled={loading || !tenantShortname || !mailTracker}
                            >
                                {loading ? 'Deleting...' : 'Delete'}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}

export default FollowupMgmtDelete
